import React from 'react';
import { motion } from 'framer-motion';
const prices = [{
  service: 'Move-Out / Move-In Cleaning',
  price: 'starting at $180'
}, {
  service: 'Deep Cleaning',
  price: 'starting at $220'
}, {
  service: 'Post-Construction Cleaning',
  price: 'starting at $350'
}, {
  service: 'Commercial Cleaning',
  price: 'starting at $350/month'
}, {
  service: 'Airbnb Turnover Cleaning',
  price: 'custom quote',
  highlight: true
}];
export function Pricing() {
  return <section id="pricing" className="py-32 bg-paper relative border-t border-concrete/30" data-id="element-161" data-mp="1rthwtnw80oag">
      <div className="container mx-auto px-8 lg:px-12 max-w-4xl" data-id="element-162" data-mp="25t0s3g3xo55c">
        <div className="text-center mb-20" data-id="element-163" data-mp="20slj10qopjt6">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-164" data-mp="20rjx2184rcwo">
            <div className="w-8 h-[1px] bg-lime" data-id="element-165" data-mp="3h6boobxgcg4x"></div>
            <span className="text-ink/50 font-body text-xs uppercase tracking-[0.3em]" data-id="element-166" data-mp="3h97j3qa3cmom">
              Investment
            </span>
            <div className="w-8 h-[1px] bg-lime" data-id="element-167" data-mp="3w08cy4tljg8s"></div>
          </div>
          <h2 className="text-4xl md:text-5xl text-ink font-light mb-6" data-id="element-168" data-mp="4t5mxgphvg05">
            Transparent <span className="font-medium" data-id="element-169" data-mp="4v8ishdbw3cs">Pricing.</span>
          </h2>
          <p className="text-ink/60 font-light text-sm" data-id="element-170" data-mp="9srzrp1euu8f">
            No hidden fees. Just premium service.
          </p>
        </div>

        <div className="flex flex-col" data-id="element-171" data-mp="eoz79m9ggdsh">
          {prices.map((item, index) => <motion.div key={item.service} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`flex flex-col sm:flex-row sm:items-end justify-between py-6 border-b border-concrete/50 group ${item.highlight ? 'text-ink' : 'text-ink/80'}`} data-id="element-172" data-mp="3d6upslw4ke3q" data-mpi={index}>
              <span className={`text-lg tracking-wide ${item.highlight ? 'font-medium' : 'font-light'}`} data-id="element-173" data-mp="2reia4epouhq4">
                {item.service}
              </span>
              <div className="hidden sm:block flex-grow border-b border-dotted border-concrete/50 mx-6 mb-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-174" data-mp="318qxknzv3khf"></div>
              <span className={`text-xs uppercase tracking-[0.2em] mt-2 sm:mt-0 ${item.highlight ? 'text-lime font-medium bg-ink px-3 py-1' : ''}`} data-id="element-175" data-mp="28is7qqdufjbp">
                {item.price}
              </span>
            </motion.div>)}
        </div>

        <div className="mt-20 text-center" data-id="element-176" data-mp="2dgty7wdlmkx7">
          <p className="text-ink/50 text-xs font-light mb-8 max-w-md mx-auto leading-relaxed" data-id="element-177" data-mp="2dj6f067mep8o">
            Prices vary based on square footage, condition, and specific
            architectural requirements.
          </p>
          <a href="#quote" className="inline-block bg-ink text-paper px-10 py-4 text-xs uppercase tracking-[0.2em] hover:bg-graphite transition-colors" data-id="element-178" data-mp="adm4tqwbzkl">
            Get Your Custom Quote
          </a>
        </div>
      </div>
    </section>;
}